import React, { useEffect, useState } from 'react';
import { FlexRow } from 'components/styled-components';
import styled from 'styled-components';
import colors from 'utils/colors';
import { NonIdealState } from '@blueprintjs/core';
import Select from 'react-select';
import hasPermission from 'utils/hasPermission';
import Permissions from 'utils/permissions';

const VendorInfo = ({
  request,
  loaded,
  vendorsLoaded,
  contacts,
  fetchContacts,
  selected,
  setContactValue,
  appUser,
}) => {
  const [options, setOptions] = useState(contacts.result);

  useEffect(() => {
    request.vendorInformation &&
      fetchContacts(request.vendorInformation.vendorName);
  }, [selected]);

  useEffect(() => {
    !!contacts && contacts.result !== options && setOptions(contacts.result);
  }, [contacts.result]);

  if (loaded && vendorsLoaded) {
    return (
      <FlexRow>
        <Wrapper>
          <SingleRowTable>
            <tbody>
              <tr>
                <th>Assessment ID</th>
                <th>Third Party</th>
                <th>Product / Service</th>
                <th>Third Party Contact</th>
                <th style={{paddingLeft: "5px"}}>Third Party Contact Email</th>
              </tr>
              <tr>
                <td>{request.vendorRequestID}</td>
                <td>{request.vendorInformation.vendorName}</td>
                <td>{request.productServiceName}</td>
                <td style={{ width: '30%' }}>
                  {hasPermission(appUser.permissions, [
                    Permissions.MODIFY_OWNED_THIRD_PARTY_REQUESTS,
                    Permissions.MODIFY_ALL_THIRD_PARTY_REQUESTS,
                  ]) ? (
                    <Select
                      value={selected}
                      onChange={selected =>
                        setContactValue('vendorContact', selected)
                      }
					  isMulti={true}
                      name="vendorContact"
                      options={options}
                      getOptionLabel={option =>
                        `${option.firstName !== null ? option.firstName: ''} ${option.lastName !== null ? option.lastName : ''}`
                      }
                      getOptionValue={option => option.userID}
                    />
                  ) : (
                    `${request.vendorContact.firstName} ${
                      request.vendorContact.lastName
                    }`
                  )}
                </td>
                <td style={{paddingLeft: "5px"}}>
					{selected.length > 0 ? selected.map(contact => <p>{contact.email}</p>)
					: request.vendorContact.map(contact => <p>{contact.email}</p>)}
				</td>
              </tr>
            </tbody>
          </SingleRowTable>
        </Wrapper>
      </FlexRow>
    );
  } else {
    return (
      <NonIdealState
        icon="error"
        title="Third Party Information Not Found"
        description="The system could not retrieve valid Third Party information."
      />
    );
  }
};

const Wrapper = styled.div`
  width: 100%;
  padding: 0.5rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const SingleRowTable = styled.table`
  width: 100%;
  text-align: left;

  th {
    font-size: 0.75rem;
    color: ${colors.gray};
  }
`;

export default VendorInfo;
